import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    quote: "Necesitábamos la justipreciación de rentas de un local comercial y el Arq. Rodríguez nos ayudó con un dictamen claro, bien fundamentado y entregado en tiempo. Excelente servicio.",
    name:  "María Fernanda López",
    role:  "Propietaria de inmueble en San Andrés Cholula",
  },
  {
    quote: "Contratamos sus servicios como DRO para una obra comercial en el centro de Puebla. Su acompañamiento fue puntual en cada visita municipal y la documentación quedó impecable.",
    name:  "Ing. Carlos Mendoza",
    role:  "Desarrollador inmobiliario, Puebla",
  },
  {
    quote: "El dictamen pericial que elaboró fue clave para resolver un proceso judicial relacionado con la división de una propiedad familiar. Trabajo riguroso, profesional y absolutamente confiable.",
    name:  "Lic. Patricia Hernández",
    role:  "Abogada civilista, Puebla",
  },
  {
    quote: "Regularizar la escritura de la casa de mis padres parecía un trámite imposible. El despacho gestionó todo con paciencia y conocimiento; en pocos meses el inmueble quedó completamente en regla.",
    name:  "José Antonio Vázquez",
    role:  "Cliente particular, Atlixco",
  },
  {
    quote: "He trabajado con varios valuadores en Puebla y ninguno tiene la trayectoria ni el nivel de detalle del Arq. Rodríguez. Su experiencia lo hace nuestra primera opción para cualquier avalúo o dictamen.",
    name:  "Lourdes Ramírez",
    role:  "Asesora inmobiliaria certificada",
  },
  {
    quote: "Solicité un peritaje técnico tras una afectación estructural en mi local. La explicación fue clara, el dictamen profesional y me sirvió para reclamar correctamente ante mi aseguradora.",
    name:  "Roberto Aguilar",
    role:  "Propietario de local comercial, Tehuacán",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonios"
      data-testid="testimonials-section"
      className="relative bg-brand-light py-24 lg:py-32 overflow-hidden"
    >
      <div aria-hidden className="absolute inset-0 bg-dots-grid bg-dots-24 opacity-60" />

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3">
            <span className="h-px w-10 bg-brand-gold" />
            <span className="label-overline">Testimonios</span>
          </div>
          <h2 className="mt-5 font-playfair text-3xl sm:text-4xl lg:text-5xl text-brand-navy leading-[1.1] tracking-tight text-balance">
            Lo que dicen <span className="italic text-brand-gold">nuestros clientes</span>
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-7">
          {TESTIMONIALS.map((t, i) => (
            <motion.article
              key={t.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.08, ease: "easeOut" }}
              className="relative bg-white border-l-[4px] border-brand-gold p-7 lg:p-8 shadow-[0_4px_24px_-12px_rgba(27,42,74,0.15)] hover:shadow-[0_24px_50px_-24px_rgba(27,42,74,0.3)] hover:-translate-y-1 transition-all duration-300"
              data-testid={`testimonial-${i}`}
            >
              <Quote
                aria-hidden
                size={64}
                className="absolute top-3 right-3 text-brand-gold/12"
                strokeWidth={1}
              />
              <div className="relative flex gap-0.5 text-brand-gold">
                {Array.from({ length: 5 }).map((_, idx) => (
                  <Star key={idx} size={15} fill="currentColor" strokeWidth={0} />
                ))}
              </div>
              <p className="relative mt-4 font-inter italic text-brand-ink/85 leading-relaxed">
                “{t.quote}”
              </p>
              <div className="relative mt-6 pt-5 border-t border-brand-navy/8">
                <div className="font-playfair text-lg text-brand-navy">{t.name}</div>
                <div className="font-mont text-[10px] uppercase tracking-[0.18em] text-brand-mute mt-1">
                  {t.role}
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
